import Icon from '../components/Icon.vue'

Icon.register({
  'chess-bishop': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M123.2 77.9C107.4 72.5 96 57.6 96 40 96 17.9 113.9 0 136 0H183.8C205.9 0 223.8 17.9 223.8 40 223.8 57.5 212.5 72.4 196.8 77.8 220.8 94.5 245.4 124.7 265.5 159.9L144.9 280.4A6-6 0 0 1 144.9 288.9L159.1 303.1A6-6 0 0 1 167.6 303.1L280.9 189.7C298.7 228 310.3 269.2 310.3 304 310.3 357.8 287.4 379.8 251.8 390V448H68.2V390C32.6 379.8 9.7 357.8 9.7 304 9.7 226 68 116.2 123.2 77.9zM320 500V476C320 469.4 314.6 464 308 464H12C5.4 464 0 469.4 0 476V500C0 506.6 5.4 512 12 512H308C314.6 512 320 506.6 320 500z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-bishop.js
// module id = dOd7
// module chunks = 144